import { Select } from 'antd'
import React, { Component } from 'react'
import { PricingAPI } from '../../controller/PricingAPI'

export class RoomCategorySelect extends Component {
    state = {
        categories: [],
    }
    componentDidMount() {
        this.setState({ loading: true });
        PricingAPI.roomcategories.index({}, 1, 999).then((response) => {
            const result = response.data;
            this.setState({ categories: result.data });
        });
        this.setState({ loading: false });
    }
    render() {
        return (
            <Select loading={this.state.loading} style={{ minWidth: 150 }} allowClear={true} {...this.props}>
                {this.state.categories.map((hotel) => <Select.Option key={hotel.id}>{hotel.name}</Select.Option>)}
            </Select>
        )
    }
}

export default RoomCategorySelect